import httpService from "./httpService";

export default {
  findById(id) {
    return httpService.get(`/hcFlowInstance/${id}`);
  }
};



// WEBPACK FOOTER //
// ./src/services/hcFlowInstanceService.js